
export default {
  computed: {
    dxDatagridTextSize: {
      get() {
        if (!this.$store.getters.uiSettingsDatagridTextSize) {
          return 'md'
        }
        return this.$store.getters.uiSettingsDatagridTextSize
      },
      set(value) {
        this.$store.commit('uiSettingsDatagridTextSize', value)
      },
    },

    edenDatagridTextClass() {
      const size = this.$store.getters.uiSettingsDatagridTextSize || 'md'
      return `eden-datagrid-font-size-${size}`
    },

    edenDatagridTextSizeOptions() {
      return [
        { value: 'sm', text: 'Small' },
        { value: 'md', text: 'Medium' },
        { value: 'lg', text: 'Large' },
        { value: 'xl', text: 'XLarge' },
      ]
    },
  },
}
